<template>
  <label for="confirm" class="flex space-x-2 items-start mt-2">
    <input
      id="confirm"
      type="checkbox"
      class="cursor-pointer appearance-none flex-shrink-0 border border-gray-300 rounded-sm"
      :checked="checked"
      @change="onChange"
    />
    <div>
      <slot></slot>
      <slot name="error"></slot>
    </div>
  </label>
</template>

<script>
export default {
  props: ["checked"],
  model: {
    prop: "checked",
    event: "change",
  },
  methods: {
    onChange(event) {
      this.$emit("change", event?.target.checked);
    },
  },
};
</script>

<style scoped>
input[type="checkbox"] {
  width: 15px;
  height: 15px;
}

input[type="checkbox"]:checked {
  background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='.5' y='.5' width='19' height='19' rx='1.5' fill='%2300CE8B' stroke='%2300CE8B'/%3E%3Cpath d='M4 10.455L8.369 14 16 6' stroke='%23fff' stroke-width='2.5'/%3E%3C/svg%3E");
  background-color: white;
  background-repeat: no-repeat;
  background-color: currentColor;
  border-color: #00ce8b;
  background-origin: border-box;
  print-color-adjust: exact;
  background-size: 100%;
  background-position: center;
}
</style>
